import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TESTS } from "./constants";

export const clearTestStorage = () => {
  TESTS.forEach((test) => {
    sessionStorage.removeItem('test-id');
    sessionStorage.removeItem(`${test}-responses`);
    sessionStorage.removeItem(`${test}-current`);
    sessionStorage.removeItem(`${test}-score`);
  })
}

export const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, search]);

  return null;
}

export const scrollToBottom = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: "smooth",
  });
}

export const redirectToPlural = () => {
  window.location.href = process.env.REACT_APP_REDIRECT_URL;
}